import { MenuItem } from "../NavMenu";
import { ListItem, ListItemText } from "@mui/material";
import { NavLink } from "react-router-dom";
import { NavbarDrawerContext, ThemeContext } from "../../root.component";
import { useContext } from "react";

type NavSubMenuProps = {
  menuItem: MenuItem;
};

export function NavSubMenu(props: NavSubMenuProps) {
  const {
    palette: {
      text: { primary: primaryMain },
      secondary: { main: secondaryMain },
    },
  } = useContext(ThemeContext);

  const { setDrawerState } = useContext(NavbarDrawerContext);

  return (
    <ListItem
      disablePadding
      key={props.menuItem.id}
      data-testid={"sub-menu-item"}
    >
      <ListItemText sx={{ padding: "4px 0px 4px 32px", margin: 0 }}>
        <NavLink
          onClick={() => {
            setDrawerState(false);
          }}
          to={props.menuItem.url}
          style={({ isActive }) => ({
            color: isActive ? secondaryMain : primaryMain,
            textDecoration: "none",
            fontSize: "14px",
          })}
          className={"nav-menu-item"}
        >
          {props.menuItem.label}
        </NavLink>
      </ListItemText>
    </ListItem>
  );
}
